import {BUILD_TYPE, getBuildType} from '@voltmoney/micro-frontend';
import {createContext} from 'react';
import {AppContextInterface} from '../../partnerWeb/configs/appContext';
import {
  createNavigationContainerRef,
  NavigationContainerRefWithCurrent,
} from '@react-navigation/core';

export const redirectToFaq = () => {
  window.open(`${PartnerLink}faq`, '_blank');
};
export const BreakPoints = {
  WEB: 1023,
};

export const AppContext: AppContextInterface = {
  user: {
    name: '',
    email: '',
    phoneNumber: '',
    otp: '',
    newUser: true,
    accessToken: '',
  },
};

export const partnerHelplineNumber = '9611749295';

export const WhatsAppLink = {
  help: `https://wa.me/91${partnerHelplineNumber}`,
  helpPartner: `https://api.whatsapp.com/send?phone=91${partnerHelplineNumber}`,
};

export const PartnerLink =
  getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION
    ? 'https://voltmoney.in/partner/'
    : 'https://staging.voltmoney.in/partner/';

export const AppCtx = createContext<AppContextInterface | null>(AppContext);
export const navigationRef: NavigationContainerRefWithCurrent<any> =
  createNavigationContainerRef();
